export default class Analytics {
  static sendEvent(eventName, eventType, eventValue, logAnalytic = false) {
    Analytics.sendAnalytic('send', 'event', eventName, eventType, eventValue, logAnalytic);
  }

  static sendAnalytic(action, kind, name, type, value, logAnalytic = false) {
    if (logAnalytic) {
      // console.log(`sendAnalytic(${action}, ${kind}, ${name}, ${type}, ${value})`);
    }

    // eslint-disable-next-line no-undef
    // This function was used for sending a google analytics event. Not used anymore.
    // ga(action, kind, name, type, value);
  }

  static EVENT_BUY_SKY = 'Buy Skycoin';
}




// WEBPACK FOOTER //
// ./src/utils/analytics.js